import { useMutation } from "@tanstack/react-query";
import { createDeckCheckout, getShippingQuotes } from "../api/shop";
import { useContent } from "./useContent";
import { deckOrderItem } from "../analytics/catalog";
import { track } from "../analytics/track";

export function useShippingQuotesMutation() {
  return useMutation({ mutationFn: getShippingQuotes });
}

export function useDeckCheckoutMutation() {
  const { data: content } = useContent();
  return useMutation({
    mutationFn: createDeckCheckout,
    onMutate: (input) => {
      const item = deckOrderItem(content, input.deckKeys.join(","));
      if (item) track({ name: "initiate_checkout", ...item });
    },
  });
}
